
import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../config/config";
import "../css/login.css";

function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!email || !password) {
            alert("Please enter email and password.");
            return;
        }

        try {

            setLoading(true);

            console.log("LOGIN API:", `${API_URL}/login`);

            const res = await axios.post(
                `${API_URL}/login`,
                {
                    email,
                    password
                }
            );

            console.log("LOGIN RESPONSE:", res.data);


            if (!res.data || !res.data.success) {

                alert(
                    res.data?.message ||
                    "Login failed."
                );

                return;
            }


            if (!res.data.user) {

                alert("Login successful, but user information was not received.");

                return;
            }


            const user = res.data.user;


            // =======================================
            // SAVE LOGIN DATA
            // =======================================

            localStorage.setItem(
                "token",
                res.data.token
            );

            localStorage.setItem(
                "user",
                JSON.stringify(user)
            );

            localStorage.setItem(
                "user_id",
                String(user.id)
            );

            localStorage.setItem(
                "name",
                user.first_name || ""
            );

            localStorage.setItem(
                "email",
                user.email || ""
            );

            localStorage.setItem(
                "role",
                user.role || "customer"
            );


            console.log(
                "LOGIN SUCCESS:",
                user
            );


            alert("Login Successful");


            // =======================================
            // REDIRECT
            // =======================================

            if (user.role === "admin") {

                navigate("/admin/dashboard");

            } else {

                navigate("/");

            }

        } catch (err) {

            console.error(
                "LOGIN ERROR:",
                err
            );

            console.error(
                "LOGIN RESPONSE:",
                err.response?.data
            );


            alert(
                err.response?.data?.message ||
                "Login failed. Please try again."
            );

        } finally {

            setLoading(false);

        }

    };


    return (

        <div className="login-page">

            <div className="login-card">

                <h1>🥃 SIPS LIQUOR</h1>

                <p>Welcome Back</p>


                <form
                    className="login-form"
                    onSubmit={handleSubmit}
                >

                    <input
                        type="email"
                        placeholder="Email Address"
                        value={email}
                        autoComplete="email"
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        required
                    />


                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        autoComplete="current-password"
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                        required
                    />


                    <div
                        style={{
                            textAlign: "right",
                            marginBottom: "15px"
                        }}
                    >

                        <Link to="/forgot-password">
                            Forgot Password?
                        </Link>

                    </div>


                    <button
                        type="submit"
                        className="login-btn"
                        disabled={loading}
                    >

                        {loading
                            ? "Logging in..."
                            : "Login"}

                    </button>

                </form>


                <div className="register-link">

                    Don't have an account?

                    {" "}

                    <Link to="/register">
                        Register
                    </Link>

                </div>

            </div>

        </div>

    );

}

export default Login;
